import type { OralExamRunStateResponseVoidCause } from '@/common/api/models/oralExamRunStateResponseVoidCause';

export type VoidReasonLine = {
  key: string;
  defaultValue: string;
};

/** Single copy source for void-family lecturer lines (tile + status card). */
export function voidReasonLine(runState: {
  voidCause?: OralExamRunStateResponseVoidCause;
  endReason?: string | null;
}): VoidReasonLine {
  if (runState.voidCause === 'supervision_absence') {
    return {
      key: 'oralExam.lecturer.cohort.voidSupervisionAbsence',
      defaultValue: 'Ended — no supervisor was present. Student must rebook.',
    };
  }
  if (runState.voidCause === 'integrity_budget_exceeded') {
    return {
      key: 'oralExam.lecturer.cohort.voidIntegrityBudgetExceeded',
      defaultValue: 'Ended — the student was offline too long. Student must rebook.',
    };
  }
  if (runState.endReason === 'agent_unavailable') {
    return {
      key: 'oralExam.lecturer.cohort.voidExaminerUnavailable',
      defaultValue: 'Ended — the examiner could not continue. Student must rebook.',
    };
  }
  return {
    key: 'oralExam.lecturer.cohort.voidSessionEndedGeneric',
    defaultValue: 'Session ended — student must rebook.',
  };
}
